import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './SearchFiltersModalV2.module.css';

const ActivityCard = props => {
  const { option, selected, iconSrc, onClick } = props;

  return (
    <button
      type="button"
      className={classNames(css.activityCard, {
        [css.activityCardSelected]: selected,
      })}
      onClick={onClick}
    >
      {iconSrc ? <img className={css.activityCardIcon} src={iconSrc} alt="" /> : null}
      <span className={css.activityCardLabel}>{option.label}</span>
    </button>
  );
};

ActivityCard.defaultProps = {
  selected: false,
  iconSrc: null,
};

ActivityCard.propTypes = {
  option: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
  selected: PropTypes.bool,
  iconSrc: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default ActivityCard;
